import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import createLogger from 'redux-logger';
import { apiMiddleware } from 'redux-api-middleware';
import rootReducer from '../reducers';
import { Map, List, OrderedSet } from 'immutable';
import apiErrorInterceptor from '../middleware/apiErrorInterceptor';
import { LIST_VIEW, INFLUENCER_TAB } from '../constants/viewTypes';

const loggerMiddleware = createLogger();

// let middleware = [
//   thunkMiddleware,
// ];

let enhancer = {};

if (process.env.NODE_ENV !== 'production') {
  enhancer = compose(
    applyMiddleware(
      thunkMiddleware,
      apiMiddleware,
      // loggerMiddleware,
      apiErrorInterceptor,
    ),
    window.devToolsExtension ? window.devToolsExtension() : f => f
  );

} else {
  enhancer = applyMiddleware(
    thunkMiddleware,
    apiMiddleware,
    apiErrorInterceptor,
  );

}

const initialState = Map({
  location: Map({
    name: '',
    options: Map(),
    request: Map({
      pathname: '',
      search: '',
    }),
  }),
  errors: List(),
  currentUser: Map(),
  users: Map({
    isFetching: false,
    items: Map(),
    result: List(),
  }),
  filterOptions: Map({
    isFetching: false,
    gamePlatforms: Map({
      entities: Map(),
      result: Map(),
    }),
    mediaPlatforms: Map({
      entities: Map(),
      result: Map(),
    }),
    gameGenres: Map({
      entities: Map(),
      result: Map(),
    }),
    channelStyles: Map({
      entities: Map(),
      result: Map(),
    }),
    socialMedia: Map({
      entities: Map(),
      result: Map(),
    }),
  }),
  activeFilters: Map({
    gamePlatformFilter: List(),
    mediaPlatformFilter: List(),
    gameGenreFilter: List(),
    channelStyleFilter: List(),
    search: '',
    searchCity: '',
    searchState: '',
    orderBy: 'default',
    order: 'ASC',
  }),
  viewState: Map({
    search: LIST_VIEW,
    tab: INFLUENCER_TAB,
    hitsPerPage: 50,
  }),
  collectives: Map({
    isFetching: false,
    items: Map(),
    result: OrderedSet(),
    page: 1,
    mergeId: 0,
    mergeIntoId: 0,
    totalSystemCount: 0,
  }),
  importer: Map({
    result: OrderedSet(),
    mergeId: 0,
    mergeIntoId: 0,
    completed: false,
  }),
  influencers: Map({
    isFetching: false,
    items: Map(),
    result: OrderedSet(),
    nextPage: 1,
    totalSystemCount: 0,
  }),
  policies: Map({
    isFetching: false,
    items: Map(),
    result: Map(),
  }),
});

const configureStore = () => createStore(
  rootReducer,
  initialState,
  enhancer
);

export default configureStore;



/** WEBPACK FOOTER **
 ** ./store/configureStore.js
 **/